import React from 'react';
import IconImg from '../../images/design-illustration.svg';

const HeroSection = () => {
  return (
    <header>
      <div className="flex flex-col lg:flex-row max-w-screen-xl mx-auto px-5 py-20 md:py-24">
        <div className=" lg:w-5/12 text-center max-w-lg mx-auto lg:max-w-none lg:text-left ">
          <h1 className="font-bold text-3xl md:text-3xl lg:text-4xl xl:text-5xl text-gray-900 leading-tight">
            Desarrollo de páginas web{' '}
            <span className="text-primary-purple">modernas para ti.</span>
          </h1>
          <p className="my-5 lg:my-8 text-base xl:text-lg">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto
            ut minus officiis, blanditiis autem placeat deleniti eligendi
            sapiente odit?.
          </p>
          <div className="flex flex-col items-center lg:flex-row justify-center lg:justify-between mt-8">
            <button className="font-bold px-8 w-52 lg:w-full lg:px-10 py-3 rounded bg-primary-purple text-gray-100 hover:bg-white transform hover:scale-105 hover:text-primary-purple hover:shadow-lg border-2 border-primary-purple hover:border-gray-100 focus:outline-none transition duration-300">
              Empezar
            </button>
            <button className="mt-4 w-52 lg:mt-0 lg:ml-8 lg:w-full font-bold px-8 lg:px-10 py-3 rounded bg-gray-50 text-primary-purple  hover:bg-white  hover:shadow-lg border-2 border-primary-purple hover:border-gray-100 transform hover:scale-105 focus:outline-none transition duration-300">
              Planes
            </button>
          </div>
        </div>
        <div className=" mt-12 lg:mt-0 flex-1 flex flex-col justify-center self-center lg:self-start">
          <div className="flex justify-center lg:justify-end ">
            <IconImg className=" min-w-0 w-full max-w-lg xl:max-w-3xl h-auto" />
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeroSection;
